import type { EntryGroupEntry } from "@/shared/cache";
import { type DaySums, emptyDaySums } from "@/v2/pages/Calendar";

/**
 * Build a Map<dayKey, DaySums> from entry-group rows.
 *
 * Day key format is `YYYY-MM-DD` (matching the format the v2 Calendar reads).
 */
export function buildDailySums(
	entries: EntryGroupEntry[],
): Map<string, DaySums> {
	const sums = new Map<string, DaySums>();
	for (const e of entries) {
		const parts = e.date.split("-");
		if (parts.length !== 3) continue;
		const key = e.date;
		const prev = sums.get(key) ?? emptyDaySums();
		const isBillable = !e.matter?.id || e.billable === true;
		if (e.status === "exported") {
			if (isBillable) prev.exportedBillable += e.units;
			else prev.exportedNonBillable += e.units;
		} else if (e.status === "tracked" || e.status === "reviewed") {
			if (isBillable) prev.trackedBillable += e.units;
			else prev.trackedNonBillable += e.units;
		}
		sums.set(key, prev);
	}
	return sums;
}
